import { Protocol } from '../Protocol';

export class SignatureProtocol {
  public static readonly SIGNATURE: string = `${Protocol.YATUNG_API_ROOT}/signature`;
  public static readonly SIGNATURE_BY_SEARCH: string = `${Protocol.YATUNG_API_ROOT}/signature/all`;
  public static readonly SIGNATURE_TEMPLATE: string = `${Protocol.YATUNG_API_ROOT}/signature/template`;
  public static readonly SIGNATURE_TEMPLATE_ORDER_ID: string = `${Protocol.YATUNG_API_ROOT}/signature/template/orderId`;
  public static readonly PAGEABLE_SIGNATURE_BY_SEARCH: string = `${Protocol.YATUNG_API_ROOT}/signature/p/all`;
}
